import makeRequest from "./makeRequest";
import { POST } from "../constants";
import getRuntimeConstants from "../runtimeConstants";

export async function sendReportReview(reviewId) {
  const { reviewsApiPath } = getRuntimeConstants();

  const handleErrorReturnValue = (error) => {
    throw error;
  };

  const response = await makeRequest({
    url: `${reviewsApiPath}/${reviewId}/report`,
    method: POST,
    apiName: "Report Review",
    caller: "Report Review",
    handleErrorReturnValue,
  });

  if (Array.isArray(response) && response[0]?.errorCode) {
    throw new Error(response[0].errorMessage || "Failed to report review");
  }
}
